import { Carousel } from '@/components';
import { Content } from '@prismicio/client';
import { PrismicNextImage } from '@prismicio/next';
import { PrismicRichText, SliceComponentProps } from '@prismicio/react';

/**
 * Props for `Achievements`.
 */
export type AchievmentsProps = SliceComponentProps<Content.AchievmentsSlice>;

/**
 * Component for "Achievements" Slices.
 */
const Achievements = ({ slice }: AchievmentsProps): JSX.Element => {
  const renderCards = () => {
    return slice.primary.cards.map((card, index) => {
      return (
        <div key={`card_${index.toString()}`}>
          <div className="bg-white rounded-[20px] text-black p-6 flex flex-col gap-y-6 mx-1">
            <PrismicNextImage field={card.icon} />
            <h3 className="text-h5">{card.title}</h3>
            <div className="w-2/3">
              <PrismicNextImage
                field={card.logo}
                className="h-9 object-contain"
              />
            </div>
          </div>
        </div>
      );
    });
  };

  return (
    <section
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
      className="text-white px-5 py-16 md:px-16 md:py-28 max-w-screen-2xl mx-auto"
    >
      <div className="flex flex-col md:gap-20 gap-16">
        <div className="flex flex-col md:flex-row md:gap-20 gap-16">
          <div className="flex flex-col gap-6 basis-0 flex-grow min-w-0">
            <PrismicNextImage field={slice.primary.icon} />
            <PrismicRichText field={slice.primary.title} />
            <PrismicRichText field={slice.primary.description} />
          </div>
          <PrismicNextImage
            field={slice.primary.photo}
            className="basis-0 flex-grow min-w-0 h-auto rounded-[20px]"
          />
        </div>
        <div className="hidden md:grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {renderCards()}
        </div>
        <div className="md:hidden">
          <Carousel dotType="compact-dark" renderDotsOutside arrows={false}>
            {renderCards()}
          </Carousel>
        </div>
      </div>
    </section>
  );
};

export default Achievements;
